<template>
  <div class="school-filter">
    <combo-box
      :auto-filter="true"
      :options="filterSchools"
      :label="currentSchoolName"
      :disabled="disabled"
      @change="handleSchoolFilter"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, nextTick } from "vue";

interface Filter {
  schoolCode: string;
}

interface Props {
  filter?: Filter | null;
  schools?: string[];
  currentSchoolCode?: string;
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  filter: null,
  schools: () => [],
  currentSchoolCode: "",
  disabled: false,
});

// Emits
const emit = defineEmits(["change"]);

// Refs
const currentSchoolName = ref("");

const searchFilters = ref<Filter>(
  props.filter || {
    schoolCode: props.currentSchoolCode,
  },
);

// Computed
const filterSchools = computed(() => {
  if (!props.schools.length) return [];
  const filteredSchools = props.schools.map((school) => {
    if (props.currentSchoolCode === school.schoolCode) {
      currentSchoolName.value = school.schoolName;
    }
    return {
      name: school.schoolName,
      label: school.schoolName,
      value: school.schoolCode,
    };
  });
  filteredSchools.unshift({
    name: "All Schools",
    label: "All Schools",
    value: "All",
  });
  return filteredSchools;
});

// Methods
const handleSchoolFilter = function (event) {
  searchFilters.value.schoolCode = event;
  emit("change", searchFilters.value);
};

// Mounted
onMounted(() => {
  nextTick(() => {
    emit("change", searchFilters.value);
  });
});
</script>
